<template>
  <v-card class="card-container">
    <div class="main-toolbar mb-4">
      <div class="icon-back">
        <v-img
          src="../../../assets/figmaIcons/white/standchecklist.svg"
          max-width="55%"
        ></v-img>
      </div>

      <span class="main-toolbar-title">{{
        $t('Cadastro Padrão - Checklist Padrão')
      }}</span>
    </div>

    <v-tabs v-model="tab" slider-color="secondary">
      <v-tab active-class="activated-tab" class="rounded-lg rounded-b-0"
        >{{ $t('Item de checklist') }}
      </v-tab>
      <v-tab active-class="activated-tab" class="rounded-lg rounded-b-0"
        >{{ $t('Template de checklist') }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-card flat class="mt-0">
          <ChecklistItem />
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat class="mt-0">
          <ChecklistTemplate />
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import ChecklistItem from './components/checklistItem/checklistItem.vue'
import ChecklistTemplate from './components/checklistTemplate/checklistTemplate.vue'

export default {
  name: 'StandardChecklistPage',

  data() {
    return {
      tab: 0,
    }
  },

  components: {
    ChecklistItem,
    ChecklistTemplate,
  },
}
</script>

<style></style>
